export default "__VITE_ASSET__Dbj2xZoh__"